/*
 * Used to store the currently signed in user
 */

import { createContext } from "react";

export const UserContext = createContext(null);
